// src/components/nodes/EntityNode.js
import { NodeBase } from './NodeBase';

export class EntityNode extends NodeBase {
  constructor() {
    super('entity', { 
      label: '新实体', 
      entityType: 'Table',
      attributes: [
        { name: 'id', type: 'int' },
        { name: 'name', type: 'string' }
      ]
    });
  }

  renderContent(data, selected) {
    return (
      <div className="entity-content">
        <div className="entity-header">
          <span className="entity-icon">📊</span>
          <span className="entity-type">
            {data.entityType}
          </span>
        </div>
        <div className="entity-name">
          {data.label}
        </div>
        {data.attributes && (
          <div className="entity-attributes">
            {data.attributes.map((attr, index) => (
              <div key={index} className="attribute">
                <span className="attr-name">
                  {attr.name}
                </span>
                <span className="attr-type">
                  {attr.type}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  getConfig() {
    return {
      type: this.type,
      label: '数据实体',
      icon: '📊',
      defaultData: this.defaultData
    };
  }
}